import React from 'react';
import { translate } from 'Shared/translate';
import { epiPropertyValue } from '@avensia/nitro5-scope-episerver';
import * as styles from './base.scss';
import Button from 'Shared/Button';
import classnames from 'classnames';
const getDisabledInfo = ({ isDeletedByMaster, isBackorderReplaced, isTender, isPantry, isDisabledForFreCustomer, }) => {
    if (isPantry && isDeletedByMaster) {
        return translate('/ProductListing/DeletedByMaster');
    }
    else if (isBackorderReplaced) {
        return translate('/Product/BackorderReplaced');
    }
    else if (!isPantry && isTender) {
        return translate('/Tender/ClientInformation');
    }
    else if (isDisabledForFreCustomer) {
        return translate('/Product/DisabledForFreCustomer');
    }
};
const getReplacementInfo = ({ isDiscontinued, isBackorderReplaced, replacementProduct, recommendedReplacementProduct, isTender, isPantry, isDisabledForFreCustomer, useShort }) => {
    if (isDiscontinued || isBackorderReplaced || isDisabledForFreCustomer) {
        if (replacementProduct && useShort) {
            return translate('/Product/RecommendedReplacementProductShort');
        }
        else if (replacementProduct) {
            return translate('/Product/ReplacementProduct');
        }
        else if (recommendedReplacementProduct && useShort) {
            return translate('/Product/RecommendedReplacementProductShort');
        }
        else if (recommendedReplacementProduct) {
            return translate('/Product/RecommendedReplacementProduct');
        }
        else {
            if (isDisabledForFreCustomer) {
                return;
            }
            return translate('/Product/NewNoRecommendedReplacementProduct');
        }
    }
    else if (!isPantry && isTender) {
        return translate('/Tender/CanOnlyBeSentThroughTender');
    }
    else {
        return translate('/Product/NewNoRecommendedReplacementProduct');
    }
};
const ProductDisabledInfo = (props) => {
    return (React.createElement(React.Fragment, null,
        !props.hideInfo && !!getDisabledInfo(props) && (React.createElement("div", { className: styles.wrap },
            React.createElement("div", { className: classnames(styles.disabledInfo, { [styles.useNewDesign]: props.useNewDesign }) }, getDisabledInfo(props)))),
        !props.hideButton && (React.createElement("div", { className: styles.wrap },
            React.createElement("div", { className: classnames(styles.replacementInfo, { [styles.useNewDesign]: props.useNewDesign }) },
                !props.isDeletedByMaster && !props.useNewDesign && getReplacementInfo(props),
                props.replacementProduct ? (React.createElement(React.Fragment, null,
                    !props.useNewDesign ? ': ' : '',
                    React.createElement("a", { "data-opti-id": "plp-replacement-button", href: props.replacementProduct.url.toString(), className: styles.replacementLink, "data-ticket": props.replacementProduct.ticket },
                        props.useNewDesign && (React.createElement(Button, { appearance: ['small', 'secondary', 'wide'] }, !props.isDeletedByMaster && getReplacementInfo(props))),
                        !props.useNewDesign && (`${translate('/ProductListing/ArticleNumber')} ${epiPropertyValue(props.replacementProduct.content.code)}`)))) : props.recommendedReplacementProduct ? (React.createElement(React.Fragment, null,
                    !props.useNewDesign ? ': ' : '',
                    React.createElement("a", { "data-opti-id": "plp-replacement-button", href: props.recommendedReplacementProduct.url.toString(), className: styles.replacementLink, "data-ticket": props.recommendedReplacementProduct.ticket },
                        props.useNewDesign && (React.createElement(Button, { appearance: ['small', 'secondary', 'wide'] }, !props.isDeletedByMaster && getReplacementInfo(props))),
                        !props.useNewDesign && (`${translate('/ProductListing/ArticleNumber')} ${epiPropertyValue(props.recommendedReplacementProduct.content.code)}`)))) : (React.createElement(React.Fragment, null, props.useNewDesign && (React.createElement("div", null, getReplacementInfo(props))))))))));
};
export default ProductDisabledInfo;
